import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = (baseURL => {
  return {
    getSessionOauth2Token: qs =>
      `${baseURL}/api/session/oauth2?${encodeParams(qs)}`,
    getAccountLimits: `${baseURL}/api/account/limits`,
    getUserSetting: (idList, dataKey) =>
      `${baseURL}/api/usersettings/list/${encodeURIComponent(
        idList
      )}/${encodeURIComponent(dataKey)}`,
    upsertUserSettings: (idList, dataKey) =>
      `${baseURL}/api/usersettings/list/${encodeURIComponent(
        idList
      )}/${encodeURIComponent(dataKey)}`,
    silencedAlerts: idList =>
      `${baseURL}/api/usersettings/list/${encodeURIComponent(
        idList
      )}/checkUpIssueVisibility`,
    notifyQeueuing: `${baseURL}/api/adm/notifyevent/queuing`,
    getSmsCosts: idList =>
      `${baseURL}/api/account/smscosts?idList=${encodeURIComponent(idList)}`,
    getSmsCredits: idList =>
      `${baseURL}/api/account/smscredits/lists/${idList}`,
    listUsers: params => `${baseURL}/api/users?${encodeParams(params)}`,
    getUser: idUser => `${baseURL}/api/users/${idUser}`,
    sendContactRequest: `${baseURL}/api/adm/notifyevent/opportunity`,
    getSmsCreditsByList: idList =>
      `${baseURL}/api/account/smscredits/lists/${encodeURIComponent(idList)}`
  }
})(process.env.BEACCOUNTSETTINGS_URL)

export const beAccountSettingsApiSendContactRequest = data => {
  const url = endpoints.sendContactRequest

  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify(data)
  }).then(res => res.data)
}

export const beAccountSettimgsGetSmsCreditsByList = idList => {
  const url = endpoints.getSmsCreditsByList(idList)
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}
export const beAccountSettimgsApiGetAccountLimits = () => {
  const url = endpoints.getAccountLimits
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const beAccountSettingsGetUserSetting = (idList, dataKey) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getUserSetting(idList, dataKey)
  }).then(({ data }) => data)
}

export const beAccountSettingsUpsertUserSettings = (
  idList,
  dataKey,
  DataValue
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.upsertUserSettings(idList, dataKey),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({ DataValue: JSON.stringify(DataValue) })
  }).then(({ data }) => data)
}

export const beAccountSettingsNotifyQueueing = data => {
  return apiWrapper({
    method: 'post',
    url: endpoints.notifyQeueuing,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(({ data }) => data)
}

export const beAccountSettingsPostUserSettings = (
  idList,
  dataKey,
  dataValue
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getUserSetting(idList, dataKey),
    headers: {
      'Content-Type': 'application/json'
    },
    data: { DataValue: JSON.stringify({ addresses: dataValue.join(';') }) }
  }).then(({ data }) => data)
}

export const beAccountSettingsGetSmsCosts = idList => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSmsCosts(idList)
  }).then(({ data }) => data)
}

export const beAccountSettingsGetAccountSmsCredits = idList => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSmsCredits(idList)
  }).then(({ data }) => data)
}

export const beAccountListUsers = params => {
  return apiWrapper({
    method: 'get',
    url: endpoints.listUsers(params)
  }).then(({ data }) => data)
}

export const beAccountSettingsGetSilencedAlerts = idList => {
  return apiWrapper({
    method: 'get',
    url: endpoints.silencedAlerts(idList)
  }).then(({ data }) => {
    return data
  })
}

export const beAccountSettingsAddSilencedAlerts = (idList, DataValue) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.silencedAlerts(idList),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({ DataValue: JSON.stringify(DataValue) })
  }).then(({ data }) => data)
}

export const beAccountSettingsApiGetUser = async idUser => {
  const url = endpoints.getUser(idUser)

  return await apiWrapper({
    method: 'get',
    url
  }).then(res => res.data)
}

export const beAccountSettingsApiGetSessionOauth2Token = async qs => {
  const response = await fetch(endpoints.getSessionOauth2Token(qs))

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`)
  }

  return await response.json()
}
